import React, { useEffect } from 'react';
import '../scss/Home.scss';
import '../scss/About.scss';
import { StaticHeader, StaticFooter } from '../components';

const About = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Navigation */}
      <StaticHeader />

      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero__container">
          <h1 className="hero__title">
            About <span className="hero__title-accent">Us</span>
          </h1>
          <p className="hero__subtitle">
            Zoobbe didn't start as a big idea.<br />
            It started as a frustration.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-section" id="story">
        <div className="container">
          <div className="section-content">
            <p>
              We were just two people — one developer and one marketer — trying to manage our projects like everyone else. Switching between Trello, ClickUp, Notion, and a dozen tabs every day. Everything felt slow. Too many features we didn't need. And the subscription bills kept growing.
            </p>
            <p>
              Eventually, we asked ourselves:
            </p>
            <p className="highlight-text">
              "Why does project management feel harder than the work itself?"
            </p>
            <p>
              We weren't trying to build the next all-in-one giant. We just wanted something simple, fast, and predictable — a tool that helped us work, not one that became more work.
            </p>
            <p>
              <strong>When we couldn't find it, we built it.</strong>
            </p>
            <p>
              Zoobbe started as a small internal tool with one goal: <strong>Do the essentials extremely well.</strong>
            </p>
            <p>
              Clean boards. Instant load times. Easy collaboration. No confusing layers. No surprise upgrades.
            </p>
            <p>
              Lightweight by design — because productivity shouldn't come with friction.
            </p>
            <p>
              The more we used it, the more we realized something important:
            </p>
            <p className="emphasis-text">
              We weren't the only ones feeling this.
            </p>
          </div>
        </div>
      </section>

      <div className="section-divider"></div>

      {/* Mission Section */}
      <section className="about-section">
        <div className="container">
          <div className="section-content">
            <p>
              So here we are, launching Zoobbe publicly with the same mindset we had on day one:
            </p>
            <p className="mission-statement">
              Make project management easy again.
            </p>
            <p className="values-list">
              Fast. Lightweight. No nonsense.
            </p>
            <p>
              Built responsibly, updated consistently, and designed to stay reliable as you grow.
            </p>
          </div>
        </div>
      </section>

      <div className="section-divider"></div>

      {/* Team Section */}
      <section className="about-section" id="team">
        <div className="container">
          <div className="section-content">
            <p>
              <strong>We're not a big team. We're not funded by huge investors.</strong>
            </p>
            <p>
              We're a developer and a marketer who manage real projects, work with real clients, and know the pain of slow, overloaded tools and built something that actually works — and keeps working.
            </p>
            <p className="emphasis-text" style={{ color: 'var(--brand-color)' }}>
              If you're tired of overcomplicated software too…<br />
              Welcome. Zoobbe was built for you.
            </p>
            <p className="dream-text">
              And we do have a simple dream:<br />
              to make project management feel effortless for anyone who just wants to get things done — without the chaos.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Join Our Journey?</h2>
            <p>Help us build the future of team collaboration. Start using Zoobbe today and be part of our growing community.</p>
            <div className="cta-actions">
              <a href="/signup" className="cta-button primary">Get Started Free</a>
              <a href="/contact" className="cta-button secondary">Get in Touch</a>
            </div>
            {/* <p className="cta-note">No credit card required • Free forever plan available</p> */}
          </div>
        </div>
      </section>

      {/* Footer */}
      <StaticFooter />
    </div>
  );
};

export default About;

